@if (showInitialCaptcha) {
  <app-recaptcha (data)="initialCaptchaFinished($event)"/>
} @else {
  @if (hasSignUpSuccess && hasSignInError) {
    <p class="login-confirmation-error">{{ 'errors.login.email_otp' | translate }}</p>
    <a class="registration-success"
       (click)="redirectToLogin(this.humanIdentifierFormat)">
      {{ 'login.v2.login_redirect' | translate }}
    </a>
  } @else {
    <form class="registration-password-form"
          [class.submitted]="submitted"
          appJumptoError
          #appJumptoError="appJumptoError"
          [formGroup]="form"
          (ngSubmit)="onSubmit()">
      @if (showPassword) {
        <div class="registration-password-form-info form-group">
          <span class="registration-password-sent"
                [innerHTML]="'login.v2.registration_password_sent' | translate:{identifier: humanIdentifierFormat}">
          </span>
          <div class="form-group"
               [ngClass]="{'has-error': formErrors.password}">
            <label class="control-label" for="otp">{{ 'login.v2.confirmation_code' | translate }}</label>
            <input class="email-otp-input form-control" type="password" formControlName="password" name="email-otp"
                   id="otp"/>
            @if (formErrors) {
              <app-input-errors
                  [errorsForField]="formErrors.password"
                  [translationKey]="'errors.register'"/>
            }
          </div>
          <span class="registration-password-resend small">
            <span>{{ 'login.v2.registration_password_resend' | translate }} </span>
            <a (click)="sendRegistrationPassword(true)">{{ 'generic.resend_password_click_here' | translate }}</a>.
          </span>
          @if (showResendCaptcha) {
            <app-password-resend-captcha (captchaFinished)="resendCaptchaFinished($event)"/>
          }
        </div>
      }
      @if (consentsData.isConsentAvailable) {
        <app-signup-consents [formGroup]="form"
                             [formErrors]="formErrors"
                             [identifierType]="identifier?.identifier_type"
                             [consentsTranslations]="consentsData.consentsTranslations"/>
        <app-privacy-policy
            formControlName="tos"
            [formErrors]="formErrors['tos'] ?? null"
            [customPrivacyPolicy]="consentsData.consentsTranslations | getConsentsTranslation:'general_privacy_policy'"/>
      }
      @if ((minimumMemberAge$ | async); as minimumMemberAge) {
        <div
            class="d-flex">
          <label [for]="input" class="control-label">
            {{ 'login.v2.confirm_age' | translate:{ minimumMemberAge: minimumMemberAge } }}
            <span class="required">*</span>
          </label>
          <input formControlName="confirmAge"
                 class="form-control"
                 type="checkbox"
                 name="input"
                 #input appFocusable (onFocusChange)="$any(input).isFocused = $event"/>
        </div>
      }
      <button [disabled]="!form.valid" type="submit" class="email-otp-submit btn btn-raised btn-block btn-primary">
        <span>{{ 'generic.button_next' | translate }}</span>
      </button>
      @if (showPassword) {
        <app-recaptcha-info/>
      }
    </form>
  }
}
